var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('cube-popup',{ref:"myPopup",attrs:{"type":"my-popup"}},[_c('cube-loading',{staticStyle:{"color":"white"},attrs:{"size":60}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }